// extracted by mini-css-extract-plugin
module.exports = {"comp":"FQA_comp__FGTSo"};